import { render } from "./bills_component.vue?vue&type=template&id=5137d23c&scoped=true"
import script from "./bills_component.vue?vue&type=script&lang=js"
export * from "./bills_component.vue?vue&type=script&lang=js"

import "./bills_component.vue?vue&type=style&index=0&id=5137d23c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5137d23c"]])

export default __exports__